<template>
  <svg
    ArrowDownRight
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M5.84 6.99L5.84 13.34"></path>
    <path d="M15.2 6.99L21.16 13.34M21.16 13.34L15.2 19.69M21.16 13.34L5.84 13.34"></path>
  </svg>
</template>

<script>
export default {
  name: "IconArrowDownRight"
};
</script>
